//import Api from '../Api.js';
import BaseView from './_BaseView.js';
import LineGraph from "../graphs/LineGraph";
import Table from "../components/Table";
import Api from "../Api";
import StackedBarChart from "../graphs/StackedBarChart.js";

export default class AnalyticsView extends BaseView {

    init() {
        super.init();

        if ($('#userActivity').length > 0) {
            LineGraph({
                container: '#userActivity',
                svg: '.user-activity',
                counter: 'steps',
                yLabel: Lang.stepstaken
            });
        }

        if ($('#siteActivity-1').length > 0) {
            LineGraph({
                container: '#siteActivity-1',
                svg: '#siteActivity-1 .site-activity',
                curved: true,
                filled: true
            });
            $('#siteActivity-1 select[name="url"]').on('change', function () {
                const val = $(this).val();
                const counter = $('#siteActivity-1 select[name="url"] option:selected').text();
                $('#siteActivity-1').data('url', val).data('counter', counter).data('ylabel', counter).trigger('update');
            });
            $('#siteActivity-1 select[name="daterange"]').on('change', function () {
                if($(this).val() === '') {
                    $(this).prop('disabled', true);
                    $('#siteActivity-1 .custom-range').show();
                    $('#siteActivity-1 .custom-select').hide();
                    $('#siteActivity-1 input[name="daterange"]').prop('disabled', false).trigger('change');

                }
            });
            $('#siteActivity-1 .reset-custom').on('click', function () {
                $('#siteActivity-1 input[name="daterange"]').prop('disabled', true);
                $('#siteActivity-1 .custom-range').hide();
                $('#siteActivity-1 .custom-select').show();
                const reset = $('#siteActivity-1 select[name="daterange"] option:eq(1)').attr('value');
                $('#siteActivity-1 select[name="daterange"]').prop('disabled', false).val(reset).trigger('change');
            });
        }

        const startsContainer = $('#monthlyStarts-1');
        if (startsContainer.length > 0) {
            StackedBarChart({
                container: '#monthlyStarts-1',
                svg: '#monthlyStarts-1 .monthly-starts',
                bar1label: startsContainer.data('bar1'),
                bar2label: startsContainer.data('bar2'),
                link: `/app/${this.app}/jumps`,
                param: 'month'
            });
            $('#monthlyStarts-1 select').on('change', function () {
                const url = new URL(`${window.location.origin}${startsContainer.data('url')}`);
                const params = new URLSearchParams(url.searchParams.toString());
                params.set('role_id', $(this).val());
                startsContainer.data('url', `${url.pathname}?${params.toString()}`);
                startsContainer.trigger('update');
            });
        }

        // const monthlyStarts = $('#monthlyStarts');
        // if (monthlyStarts.length > 0) {
        //     StackedBarChart({
        //         container: '#monthlyStarts',
        //         svg: '.monthly-starts',
        //         bar1label: monthlyStarts.data('bar1label'),
        //         bar2label: monthlyStarts.data('bar2label'),
        //         link: `/app/${this.app}/jumps`,
        //         param: 'month'
        //     });
        // }

        // if ($('#siteActivity').length > 0) {
        //     LineGraph({
        //         container: '#siteActivity',
        //         svg: '.site-activity',
        //         curved: true,
        //         filled: true
        //     });
        // }

        // if ($('#navPaths').length > 0) {
        //     Sunburst({
        //         url: '/api/analytics/nav_paths',
        //         wrapper: '#navPaths',
        //         graphArea: '#nav-paths',
        //         containerName: 'navPathContainer',
        //     });
        // }

        if ($('#pageanalytics').length > 0) {
            this.visitTable = new Table('pageanalytics', '/api/analytics/total_visits', [
                {data: 'path', orderable: true},
                {data: 'total'},
                {data: 'tools', orderable: false},
            ]);
        }

        if ($('#allStepMissingTable').length > 0) {
            this.stepMissingTable = new Table('allStepMissingTable', '/api/event/allmisses', [
                {data: 'time'},
                {data: 'user'},
                {data: 'guide'},
                {data: 'step'},
                {data: 'version'},
                {data: 'selector'},
                {data: 'type'},
                {data: 'action'},
            ]);
        }

        if ($('#userAnalyticsTable').length > 0) {
            this.userTable = new Table('userAnalyticsTable', '/api/users/analytics_table', [
                {data: 'firstname', orderable: true},
                {data: 'lastname'},
                {data: 'email'},
                {data: 'created_at'},
                {data: 'lastlogin'},
                {data: 'sysadmin'},
                {data: 'tools', orderable: false},
            ]);
        }

        if ($('#guideAnalyticsTable').length > 0) {
            this.guideTable = new Table('guideAnalyticsTable', '/api/guides/analytics_table', [
                {data: 'title', orderable: true},
                {data: 'active'},
                {data: 'version'},
                {data: 'started'},
                {data: 'completed'},
                {data: 'tools', orderable: false},
            ]);
        }
        // Role analytics has not been implemented yet.
        if ($('#roleAnalyticsTable').length > 0) {
            this.roleTable = new Table('roleAnalyticsTable', '/api/role/analytics_table', [
                {data: 'title', orderable: true},
                {data: 'description'},
                {data: 'guides', orderable: false},
                {data: 'tools', orderable: false},
            ]);
        }

        $('body').on('click', '.new-audit', () => {
            const app = $('[data-app]').data('app');
            Api.send(`/api/audit/prepare?app=${app}`, {}, 'post').done(r => {
                $('.latest-audit').empty();
                this.checkAudit(r.id);
            });
            return false;
        });
    }

    checkAudit(reportId) {
        const app = $('[data-app]').data('app');
        $('.new-audit').hide();
        $('.latest-audit').append(Lang.generatingreport);
        let interval = null;
        interval = setInterval(() => {
            Api.send(`/api/audit/check/${reportId}`).done(r => {
                if (r.completed) {
                    clearInterval(interval);
                    $('.latest-audit').empty().append(`<a href="/api/audit/latest?app=${app}">${r.filename}</a>`);
                    $('.new-audit').show();
                } else if (r.failed) {
                    clearInterval(interval);
                    $('.latest-audit').empty().append('An error has occurred.');
                    $('.new-audit').show();
                } else {
                    $('.latest-audit').append('.');
                }
            }).fail(() => {
                clearInterval(interval);
                $('.latest-audit').empty().append('An error has occurred.');
            });
        }, 3000);
    }

    setEvents() {
        super.setEvents();
    }
}
